import { SearchInput, DateInput, ReferenceInput, SelectInput } from "react-admin";

const FilterCustomerPassportPhysicalMaster = [
  <SearchInput source="q" alwaysOn />,
  <ReferenceInput label="Ponto de Retirada" source="collection_point_passport_id" reference="setup/passport-physical-collection-points-passport">
    <SelectInput
      label="Ponto de Retirada"
      optionText="name"
      optionValue="id"
      variant="outlined"
      margin="none"
      sx={{ backgroundColor: "white" }}/>
  </ReferenceInput>,
  <DateInput source="date_withdrawal_init" label="Data de Entrega Inicial" />,
  <DateInput source="date_withdrawal_end" label="Data de Entrega Final" />
];

export default FilterCustomerPassportPhysicalMaster;
